import { useQuery } from '@tanstack/react-query';

import { proTreeApi } from '@/features/pro-tree/api/pro-tree.adapter';

// Shared across PRD 04/05/06 once they all ship. Keep the cache key short so a
// single fetch serves every consumer in the session.
export const proTreeQueryKeys = {
  all: ['pro-tree'] as const,
};

export function useProTreeQuery() {
  return useQuery({
    queryKey: proTreeQueryKeys.all,
    queryFn: () => proTreeApi.listProTree(),
    // The tree changes only when PRD 04 edits it. 5 min is plenty for an
    // authoring session and avoids refetching as the user clicks between items.
    staleTime: 5 * 60 * 1000,
  });
}
